/*!

=========================================================
* Argon Dashboard React - v1.2.4
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import { Link } from "react-router-dom";
import React, { useState, useEffect } from "react";
// reactstrap components
import {
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Form,
  FormGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
  InputGroup,
  Navbar,
  Nav,
  Container,
  Media,
} from "reactstrap";
import {api} from '../../../../api'
import Cookies from 'js-cookie';

const AdminNavbar = (props) => {
  const [tasks, setTasks] = useState({
    username : '',
    profile_image: ''
  });

  const cookieId = Cookies.get('token');

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch company_id and emp_id from cookies
        const company_id = Cookies.get('company_id');
        const emp_id = Cookies.get('emp_id');
        if (!company_id || !emp_id) {
          throw new Error('Missing company_id or emp_id in cookies');
        }
        const response = await api.get(`PMprofileView.php?company_id=${company_id}&emp_id=${emp_id}`);
        setTasks({
          username : response.data.emp_name,
          profile_image : response.data.profile_image
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);


  // console.log(tasks);


  const handleLogout = async () => {
    try {
      const emp_id = Cookies.get('emp_id');
      const company_id = Cookies.get('company_id');
      const response = await api.get(`logout.php?emp_id=${emp_id}&company_id=${company_id}`);
      console.log(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    // Remove token cookie
    document.cookie = 'token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';

    // Remove path cookie
    document.cookie = 'path=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';

    // Remove role cookie
    document.cookie = 'role=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';

    // Optionally, you can also clear any local storage or session storage
    localStorage.clear();
    sessionStorage.clear();

    // Redirect to login page
    window.location.href = '/login';
  };
  
  return (
    <>
      <Navbar className="navbar-top navbar-dark" expand="md" id="navbar-main">
        <Container fluid>
          <Link
            className="h4 mb-0 text-black text-uppercase d-none d-lg-inline-block"
            to="/hr-admin/hr-management/dashboard"
          >
            {props.brandText}
          </Link>
          <Nav className="align-items-center d-none d-md-flex" navbar>
            <UncontrolledDropdown nav>
              <DropdownToggle className="pr-0" nav>
              <Media className="align-items-center">
                   <Media className="mr-3 d-none d-lg-block">
                    <span className="mb-0 text-sm font-weight-bold" style={{color:'black'}}>
                     
                      Hello, {tasks.username}!
                    </span>
                  </Media>
                  <span className="avatar avatar-sm rounded-circle">
                    {tasks.profile_image && // Render img tag only if profile_image is not null or empty
                      <img
                      style={{
                        width: '50px',
                        height: '40px',
                      }}
                        alt="..."
                        src={window.location.hostname === 'localhost' 
                            ? require(`../../../images/${tasks.profile_image}`)
                            : `/images/${tasks.profile_image}`}
                        onError={e => { e.target.onerror = null; e.target.src = '/images/default-profile.png'; }}
                      />
                    }
                  </span>
                 
                </Media>
              </DropdownToggle>
              <DropdownMenu className="dropdown-menu-arrow" right>
                <DropdownItem className="noti-title" header tag="div">
                  <h6 className="text-overflow m-0">Welcome!</h6>
                </DropdownItem>
                <DropdownItem to="/hr-admin/hr-management/user-profile3" tag={Link}>
                  <i className="ni ni-single-02" />
                  <span>My profile</span>
                </DropdownItem>
                <DropdownItem divider />
                <DropdownItem  onClick={() => handleLogout('token')}>
                <i className="ni ni-user-run" />
                <span>Logout</span>
              </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </Nav>
        </Container>
      </Navbar>
    </>
  );
};


export default AdminNavbar;
